import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetDeliveryStatsForProjectRPC } from "./getDeliveryStatsForProjectRPC";

export class GetDeliveryStatsForProjectRPCClientImpl extends GetDeliveryStatsForProjectRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetDeliveryStatsForProjectRPC.Request): Promise<LeoRPCResult<GetDeliveryStatsForProjectRPC.Response, GetDeliveryStatsForProjectRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetDeliveryStatsForProject",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetDeliveryStatsForProjectRPC.ResponseDTO,
      GetDeliveryStatsForProjectRPC.Errors.ErrorsDTO,
      GetDeliveryStatsForProjectRPC.Response,
      GetDeliveryStatsForProjectRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetDeliveryStatsForProject",
      GetDeliveryStatsForProjectRPC.Response.fromDTO,
      GetDeliveryStatsForProjectRPC.Errors.fromDTO
    );
  }
}
